import { utils, writeFile } from 'xlsx';
import { BalanceGroup, BalanceData } from 'pages/finance/balance/components/filters/types';
import { generateDateTimeFilename } from 'helpers/dateHelper';

type ExcelRow = Array<string | number>;

// Маппинг ID полей к названиям строк в Excel
const ROW_LABELS = {
  balanceTitle: 'Balance Name',
  balanceType: 'Balance Type',
  availableBalance: 'Balance',
  currency: 'Currency',
};

// Порядок строк в Excel
const ROW_ORDER = [
  'balanceTitle',
  'balanceType',
  'availableBalance',
  'currency',
];

function generateExcel(data: BalanceGroup[]) {
  const wb = utils.book_new();
  const excelData: ExcelRow[] = [];

  // Add headers
  excelData.push(Object.values(ROW_LABELS));

  data.forEach((balanceGroup: BalanceGroup, index: number) => {
    const { rows } = balanceGroup;

    rows.forEach((balanceData: BalanceData) => {
      const rowData: ExcelRow = [];
      ROW_ORDER.forEach((rowId) => {
        rowData.push(balanceData[rowId]);
      });

      excelData.push(rowData);
    });
  });

  const ws = utils.aoa_to_sheet(excelData);
  ws['!cols'] = [{ wch: 30 }, { wch: 30 }, { wch: 30 }, { wch: 30 }];
  utils.book_append_sheet(wb, ws, 'Balances');

  const fileName: string = generateDateTimeFilename('xlsx', 'real_time_balance_');

  writeFile(wb, fileName);
}

export { generateExcel };
